import { XIcon } from "@heroicons/react/outline";
import { HTMLProps } from "react";


interface Props extends HTMLProps<HTMLDivElement> {
  height: number
  isVisible: boolean;
  setIsVisible: (f: boolean) => void;
}

function AppBannerHubspot(props: Props) {
  const { height, isVisible, setIsVisible } = props;

  if (!isVisible)
    return null;

  return (
    <div className="relative w-full bg-[#f57722] text-white flex items-center justify-center gap-12 flex-shrink-0" style={{ height }}>
      <div className="font-gilroy font-semibold">
        Portant just got named one of HubSpot’s Essential Apps 2025 ⚡️
      </div>
      <a className="text-sm font-semibold hover:underline" href={"https://app.hubspot.com/ecosystem/23485196/marketplace/apps/portant-hubspot-google-docs-integration"} target="_blank" rel="noreferrer">
        Install App on HubSpot
      </a>
      <XIcon className="absolute w-6 h-6 right-12 cursor-pointer opacity-50 hover:opacity-100" onClick={() => setIsVisible(false)} />
    </div>
  )
}

export default AppBannerHubspot;
